import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function GettingHere() {
  return (
    <div className="bg-[#FAFAF8] text-[#1C1C1A] min-h-screen">
      <Helmet>
        <title>Getting to Inner Lakes Marina, Athlone | Aquastays</title>
        <meta name="description" content="Driving via the M6, trains from Dublin and Galway, parking and self check-in directions for your houseboat stay at Inner Lakes Marina, Athlone." />
        <link rel="canonical" href="https://aquastays.com/getting-here" />
      </Helmet>

      <Header solid />

      <main className="max-w-[860px] mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <p className="eyebrow text-[#6B6B65] mb-4">Directions &amp; travel</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-[#1C1C1A] tracking-tight leading-tight mb-6">
          Getting to Inner Lakes Marina.
        </h1>
        <p className="text-sm text-[#6B6B65] font-light leading-relaxed mb-14 max-w-xl">
          The marina sits on the eastern shore of Lough Ree, just outside Glasson village in Co. Westmeath — about 8 km from Athlone town centre and 75 minutes from Dublin by road.
        </p>

        <div className="space-y-14">
          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">By car from Dublin (75 min)</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Take the M4/M6 motorway west toward Athlone (exit 13). Follow signs for Glasson / Killinure. At Glasson village, turn toward Killinure and continue to Inner Lakes Marina. Free parking is available directly alongside the houseboat. Full arrival directions including the exact address and what3words location are sent with your booking confirmation.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">By train from Dublin (1 hr 20 min)</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Irish Rail operates frequent services from Dublin Heuston and Dublin Connolly to Athlone. From Athlone train station, the marina is approximately 10 minutes by taxi or rideshare. We recommend pre-booking a taxi from one of the local firms in Athlone.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">By train from Galway (1 hr)</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Galway to Athlone is served by Irish Rail. From Athlone station, take a taxi to Inner Lakes Marina — about 10 minutes.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">Parking at the marina</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Free private parking is available directly alongside the houseboat at Inner Lakes Marina. No booking required — your space is included with your stay.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">Self check-in</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Full step-by-step arrival instructions, a lockbox code and the exact berth location are sent to you before your stay. You don't need to meet anyone — just park, follow the directions and you're on board within minutes.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-[#1C1C1A] text-lg mb-4">Nearby restaurants &amp; amenities</h2>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              The Chalets Restaurant is 1 km from the marina — a local favourite for dinner. Glasson Lakehouse Hotel is 1.5 km away. Athlone town centre (8 km) has supermarkets, pharmacies, Athlone Castle and plenty of pubs and restaurants. The nearest petrol station is in Glasson village.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-10 border-t border-[#1C1C1A]/8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <p className="text-sm text-[#6B6B65] font-light">Ready to plan your stay?</p>
          <div className="flex gap-4 flex-wrap">
            <Link to="/lough-ree-things-to-do" className="text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#1C1C1A] hover:text-[#E8970A] transition-colors">
              Things to do nearby →
            </Link>
            <a href="https://aquastays.guestybookings.com/en/properties/69dff123051f000012a8ddb6" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#E8970A] hover:bg-[#D08500] text-white font-semibold text-sm transition-colors">
              Check availability
            </a>
          </div>
        </div>

        <p className="mt-10 text-xs text-[#6B6B65]">
          Questions? See our <Link to="/faq" className="underline underline-offset-2 hover:text-[#1C1C1A]">FAQs</Link> or <a href="/#contact" className="underline underline-offset-2 hover:text-[#1C1C1A]">contact us</a>.
        </p>
      </main>

      <Footer />
    </div>
  );
}
